export type ConnectedSourceCard = {
  name: string;
  icon: string;
  className: string;
  connected: boolean;
};

export const CONNECTED_SOURCES: ConnectedSourceCard[] = [
  { name: "Shopify", icon: "/Icons/Shopify.svg", className: "shopify", connected: true },
  { name: "GoogleAds", icon: "/Icons/Ads.svg", className: "google-ads", connected: true },
  {name: "GoogleAnalytics4",icon: "/Icons/GA.svg",className: "google-analytics",connected: true,},
  { name: "Zid", icon: "/Icons/zidsvg.svg", className: "zid", connected: true },
  { name: "Salla", icon: "/Icons/sallapng.png", className: "salla", connected: true },
  { name: "Meta", icon: "/Icons/metalogo.webp", className: "facebook", connected: true },
  { name: "Instagram", icon: "/Icons/Instalogo.png", className: "instagram", connected: true },
  { name: "TikTok", icon: "/Icons/TikTok_logo.svg", className: "tiktok", connected: true },
  { name: "Snapchat", icon: "/Icons/snapchat_logo.webp", className: "snapchat", connected: true },
  { name: "WhatsApp", icon: "/Icons/whatsapppng.png", className: "whatsapp", connected: true },
  { name: "Blinkco", icon: "/Icons/blinkopng.png", className: "blinkco", connected: true },
  { name: "Odoo", icon: "/images/odoo.svg", className: "odoo", connected: true },
];
